module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-left"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "/baseservice",
      "router": true
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('el-menu-item', {
      attrs: {
        "index": item.path
      }
    }, [_c('i', {
      staticClass: "el-icon-menu"
    }), _vm._v(_vm._s(item.name))])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-07bff432"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainNav.vue
// module id = 501
// module chunks = 1